import { ErrorHandler, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { INGXLoggerConfig, NGXLogger } from 'ngx-logger';

import { AppSettingsService } from 'src/app/services/app-settings.service';
import { HttpService } from 'src/app/services/http.service';
import { MaskedLogData, prepareMaskedLogData } from './MaskSensativeData';

@Injectable({
  providedIn: 'root'
})
export class LoggerService extends ErrorHandler {

  private readonly LOGGER_ENDPOINT = 'logger';

  constructor(
    private logger: NGXLogger,
    private appSettings: AppSettingsService,
    private http: HttpService,
    private router: Router
  ) {
    super();

    this.logger.updateConfig({
      serverLoggingUrl: this.appSettings.resourceUrl + this.LOGGER_ENDPOINT,
      level: this.appSettings.ngxLogging.level,
      serverLogLevel: this.appSettings.ngxLogging.serverLogLevel,
      setWithCredentialsOptionValue: true
    } as INGXLoggerConfig);

  }

  /** Override the base handleError function called by angular  */
  handleError(error) {
    this.warning(error);
  }

  info(value: any, ...additional: any[]) {
    var maskedData = this.prepareForErrorSending(additional, value, false);
    this.logger.info(maskedData.value, maskedData.additionalData);
  }

  debug(value: any, ...additional: any[]) {
    var maskedData = this.prepareForErrorSending(additional, value, false);
    this.logger.debug(maskedData.value, maskedData.additionalData);
  }

  warning(error: any, ...additional: any[]) {
    var maskedData = this.prepareForErrorSending(additional, error);
    this.logger.warn(maskedData.value, maskedData.additionalData);
  }

  error(error: any, ...additional: any[]) {
    var maskedData = this.prepareForErrorSending(additional, error);
    this.logger.error(maskedData.value, maskedData.additionalData);
  }

  fatal(error: any, ...additional: any[]) {
    var maskedData = this.prepareForErrorSending(additional, error);
    this.logger.fatal(maskedData.value, maskedData.additionalData);
  }

  private preLogLogic() {
    this.logger.setCustomHttpHeaders(this.http.generateDefaultHeaders());
  }

  private getCurrentUrlObject() {
    return {url: this.router.url};
  }

  private getRequestObject(originalRequest) {
    return originalRequest ? {originalRequest} : null;
  }

  private prepareForErrorSending(additional: any[], value: any = null, enrichAdditional: boolean = true) : MaskedLogData {
    this.preLogLogic();
    const fullAdditional = this.updateAdditional(additional, value);
    const maskedData = prepareMaskedLogData(value, fullAdditional);
    return maskedData;
  }

  private updateAdditional(additional: any[], error: any = null) {
    if (!additional) {
      additional = [];
    }

    additional.push(this.getCurrentUrlObject());
    additional.push(this.getRequestObject(error?.originalRequest));

    return additional;
  }
}
